import player from '@motionelements/helper/player/index.js';

export default (context, inject) => {
  inject('audioPlayer', player.audioPlayer);
  inject('videoPlayer', player.videoPlayer);

  context.$audioPlayer = player.audioPlayer;
  context.$videoPlayer = player.videoPlayer;
};
